import { styled } from '@mui/material/styles';
import { Card, Stack, Container, Typography, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

// components & assets
import LoginForm from './LoginForm';
import MHidden from '../../Components/Mhidden';
import Logo from '../../Components/Logo';
import LoginSvg from '../../assets/svgs/login.svg';

const RootStyle = styled('div')(({ theme }) => ({
	[theme.breakpoints.up('md')]: {
		display: 'flex',
		height: '100vh',
		justifyContent: 'center',
		alignItems: 'center',
		width: '100%'
	}
}));

const ContentStyle = styled('div')(({ theme }) => ({
	maxWidth: 480,
	margin: 'auto',
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	padding: theme.spacing(12, 0),
	color: theme.palette.primary.main
}));

const SectionStyle = styled(Card)(({ theme }) => ({
	width: '100%',
	maxWidth: 464,
	maxHeight: '100vh',
	minHeight: '90vh',
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	alignItems: 'center',
	margin: theme.spacing(2, 0, 2, 2),
	boxShadow: 16
}));

export default function Login() {
	return (
		<RootStyle>
			<MHidden width="mdDown">
				<SectionStyle>
					<img src={LoginSvg} alt="login" />
				</SectionStyle>
			</MHidden>

			<Container maxWidth="sm">
				<ContentStyle>
					<Stack sx={{ mb: 5 }}>
						<Typography variant="h3" gutterBottom fontWeight="bold">
							Login
						</Typography>
						<Typography sx={{ color: 'text.secondary' }}>Enter your details below.</Typography>
					</Stack>
					<LoginForm />
				</ContentStyle>
			</Container>
		</RootStyle>
	);
}
